import type { DefaultConfiguration } from "@/types";

import { SupportInfo } from ".";

interface Props {
  id?: null | number;
  onBack: () => void;
  supportGuide?: DefaultConfiguration["supportGuide"];
}

export const SupportInfoWrapper: React.FC<Props> = ({ id, onBack, supportGuide }) => {
  const item = supportGuide?.titles?.find((t) => t.id === id);

  if (!item) {
    return <div>Support info not found.</div>;
  }

  return <SupportInfo lists={item.guideSections || []} onBack={onBack} title={item.heading} />;
};
